<template>
    <div>
        <span style="white-space: nowrap">
            {{this.realContent}}
        </span>
    </div>
</template>
<script>

import {formatAsDecimal} from "src/common/format";

export default {
    methods: {
    },
    computed: {
    	realContent() {
			let from = this.params.data[this.params.fromType];
			let to = this.params.data[this.params.toType];
			let showPercentSign = this.params.isPercentage;
			if (showPercentSign) {
			    let params = {showPercentSign: true};
				if (from && to) {
					return formatAsDecimal(from, params) + " - " + formatAsDecimal(to, params)
				} else if(from) {
					return "> " + formatAsDecimal(from, params)
				} else if (to) {
					return "< " + formatAsDecimal(to, params)
				}
            } else {
                if (from !== undefined && to !== undefined) {
                    return formatAsDecimal(from) + " - " + formatAsDecimal(to)
                } else if(from !== undefined) {
                    return "> " + formatAsDecimal(from)
                } else if (to !== undefined) {
                    return "< " + formatAsDecimal(to)
                }
            }
        }
    }
};
</script>
